import { render, staticRenderFns } from "./phoneShow.vue?vue&type=template&id=4673c4bc&scoped=true"
import script from "./phoneShow.vue?vue&type=script&lang=js"
export * from "./phoneShow.vue?vue&type=script&lang=js"
import style0 from "./phoneShow.vue?vue&type=style&index=0&id=4673c4bc&prod&lang=scss&scoped=true"
import style1 from "./phoneShow.vue?vue&type=style&index=1&id=4673c4bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4673c4bc",
  null
  
)

export default component.exports